function getPlaceData(place) {
  const placeData = place || {}

  if (placeData.name && placeData.displayName) {
    return placeData
  }

  const name = placeData.itemName || placeData.name || ''

  return {
    type: placeData.type,
    name: name.trim(),
    displayName: getDisplayName(placeData),
    isoCountryCode: placeData.countryCode || placeData.isoCountryCode,
    id: placeData.id,
    cityID: placeData.cityID,
    stateName: placeData.provinceName || '',
    countryName: placeData.countryName || '',
    latitude: placeData.lat || placeData.latitude || '',
    longitude: placeData.lon || placeData.longitude || '',
  }
}

export function getDisplayName(place) {
  if (!place || Object.keys(place).length === 0) {
    return ''
  }

  const countryCode = place.countryCode || place.isoCountryCode
  const country = place.countryName || place.country
  const cityName = place.cityName || ''

  const stateOrCountry =
    (isCountryCodeUSorCA(countryCode) && place.stateCode && /\w{2}/.test(place.stateCode)
      ? place.stateCode
      : country) || ''

  return stateOrCountry
    ? `${cityName.trim()}${cityName ? ', ' : ''}${stateOrCountry.trim()}`
    : cityName.trim()
}

function isCountryCodeUSorCA(countryCode = '') {
  return /^us/i.test(countryCode) || /^ca/i.test(countryCode)
}

export default getPlaceData
